import CustomSpin from '../../../elements/CustomSpin'
import React, { Component } from 'react'
import { Col, message, Row } from 'antd'
import AddEvent from '../Modal/AddEvent'
import EditEvent from '../Modal/EditEvent'
import moment from 'moment'
import Events from '../../../api/Events'
import LeavesApi from '../../../api/Leaves'
import { pick } from 'lodash'
import CalendarsMenu from './CalendarsMenu'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import CalendarView from '../../../components/Main/Calendar/CalendarView'

export default class Calendar extends Component {
  uuid = 0
  state = {
    visible: false,
    visibleEvent: false,
    fetchingEvents: true,
    event: { start: moment(), end: moment() },
    fetchingCalendars: true,
    info: { start: moment(), end: moment() },
    calendars: [],
    selectedCalendars: [],
    events: [],
    cachedEvents: [],
  }
  api = new Events()
  leavesApi = new LeavesApi()

  async componentDidMount() {
    await this.fetchCalendars()
    await this.fetch()
  }

  fetchCalendars = async () => {
    this.setState({ fetchingCalendars: true })
    let response = await this.api.calendars.list()
    const calendars = await response.json()
    calendars.push({
      _key: 'leaves',
      _id: 'leaves',
      //color: '#429d55',
      color: '#0D9488',
      kind: 'leaves',
      name: `Who's Away`,
      description: "Who's Away List",
      location: 'Malaysia',
      timeZone: 'Asia/Kuala_Lumpur',
    })
    const selectedCalendars = calendars.map((c) => c._id)
    this.setState({ calendars, selectedCalendars, fetchingCalendars: false })
  }

  fetch = async () => {
    try {
      this.setState({ fetchingEvents: true })
      let response = await this.api.list()
      const events = await response.json()
      const leaves = await this.leavesApi.list({ status: 'Approved' })
      const leavesMapped = leaves.map((l) => ({
        ...pick(l, ['_key', '_id', '_rev', 'owner']),
        name: l.owner.fn,
        calendar: { _id: 'leaves', name: `Who's Away` },
        start: { date: l.date.start, dateTime: l.date.start },
        end: { date: l.date.end, dateTime: l.date.end },
        owner: { _id: 'members/5764839915673', fn: 'Aymen Taher Al-Ashwal' },
      }))
      const eventsJoined = [...events, ...leavesMapped]
      const filtered = eventsJoined.filter((e) => this.state.selectedCalendars.indexOf(e.calendar._id) > -1)
      this.setState({
        events: filtered,
        cachedEvents: eventsJoined,
        fetchingEvents: false,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        fetchingEvents: false,
      })
    }
  }
  handleCancel = async (updated) => {
    this.setState({ visible: false, visibleEvent: false })
    if (updated === true) await this.fetch()
  }
  handleSelect = (slotInfo) => {
    this.setState({ visible: true, info: slotInfo })
  }
  handleSelectEvent = (event) => {
    if (event.calendar._id !== 'leaves') this.setState({ visibleEvent: true, event })
  }
  onChange = (_id) => {
    let selectedCalendars = this.getToggledValues(this.state.selectedCalendars, _id)
    const filtered = this.state.cachedEvents.filter((e) => selectedCalendars.indexOf(e.calendar._id) > -1)
    this.setState({ selectedCalendars, events: filtered })
  }

  getToggledValues = (prevValues = [], nextValues) => {
    const newValues = [...prevValues]
    if (nextValues.constructor !== Array) {
      nextValues = [nextValues]
    }
    nextValues.forEach((value) => {
      const pos = newValues.indexOf(value)
      if (pos > -1) {
        newValues.splice(pos, 1)
      } else {
        newValues.push(value)
      }
    })
    return newValues
  }

  render() {
    const { fetchingCalendars, calendars, selectedCalendars } = this.state
    return (
      <div className="flex flex-col w-full bg-gray-50 p-2">
        <AddEvent
          calendars={this.state.calendars}
          fetch={this.fetch}
          key={this.uuid++}
          visible={this.state.visible}
          info={this.state.info}
          handleCancel={this.handleCancel}
        />
        <EditEvent
          calendars={this.state.calendars}
          fetch={this.fetch}
          key={this.uuid++}
          visible={this.state.visibleEvent}
          info={this.state.event}
          handleCancel={this.handleCancel}
        />
        <div className="py-6 px-4">
          <h1 className="text-3xl font-bold leading-tight text-gray-900">Calendar</h1>
        </div>
        <div className="flex flex-row w-full mb-10">
          <div className="flex-none">
            <CalendarsMenu
              fetching={fetchingCalendars}
              calendars={calendars}
              selectedCalendars={selectedCalendars}
              handleClick={this.handleClick}
              onChange={this.onChange}
            />
          </div>
          <div className="flex-grow" />
          <div className="flex-none">
            <RefreshButton onClick={this.fetch} />
          </div>
        </div>

        <div className="flex flex-col flex-grow space-y-2 0-2">
          <CalendarView
            fetching={this.state.fetchingEvents}
            events={this.state.events}
            calendars={this.state.calendars}
            handleCancel={this.handleCancel}
            handleSelectEvent={this.handleSelectEvent}
            handleSelect={this.handleSelect}
          />
        </div>
      </div>
    )
  }
}
